import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const Filters = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const ToolbarActions = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const ActionItem = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const Modals = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const EmptyPage = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const CardBody = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const Content = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const TableRowBody = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const TableCellBody = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const TableCellExpandBody = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const ProfileHeadDiv = styled.div`
  width: 95%;
  margin: 0 auto;
  padding: 1.5rem 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export { ActionItem, CardBody, Content, EmptyPage, Filters, Modals, ProfileHeadDiv, TableCellBody, TableCellExpandBody, TableRowBody, ToolbarActions };
TableCellBody.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  render: PropTypes.func,
  children: PropTypes.any
};